export default __webpack_public_path__ + "static/logo-green-f3aba9f77fc496330f8d9de30a4d7d76.svg";